import React from 'react'

import {Button, Modal, P} from '../UI/index.js'
import NotificationContent from './NotificationContent.js'
import {isWithinPopupPeriod, sortNotificationsByScheduled} from '../../../utils/notifications.js'
import t from '../../helpers/Languages.js'
import {formSpacing} from '../UI/forms/index.js'

class NotificationsPopup extends React.Component {
    constructor(props) {
        super(props)

        this.initialState = {
            modalIsOpen: false,
            newNotifications: [],
            currentFeatureIndex: 0
        }

        this.state = JSON.parse(JSON.stringify(this.initialState))
    }

    open() {
        this.setState({modalIsOpen: true})
    }

    close() {
        this.setState(this.initialState)
    }

    onDismiss() {
        const {newNotifications} = this.state

        // Closing with Esc or the cross also counts as read, including the notifications not shown yet
        if (newNotifications.length && typeof this.props.onClickReadNotifications === 'function') {
            this.props.onClickReadNotifications(newNotifications.map(({_id}) => _id))
        }

        this.close()
    }

    checkIfNewNotification(showAll) {
        const {notifications, user} = this.props

        if (!notifications || !user || showAll) return

        const newNotifications = sortNotificationsByScheduled(notifications.filter((notification) => !notification.isRead && isWithinPopupPeriod(notification)))

        if (newNotifications.length) {
            this.setState({modalIsOpen: true, newNotifications})
        }
    }

    onClickNextNotification() {
        const {currentFeatureIndex, newNotifications} = this.state
        const {notifications} = this.props
        const nextFeatureindex = currentFeatureIndex + 1

        const availableNotifications = newNotifications?.length > 0 ? newNotifications : notifications?.length > 0 ? notifications : []

        if (typeof this.props.onClickReadNotifications === 'function') {
            this.props.onClickReadNotifications(availableNotifications[currentFeatureIndex]._id)
        }

        if (availableNotifications[nextFeatureindex]) {
            this.setState({currentFeatureIndex: nextFeatureindex})
        } else {
            this.close()
        }
    }

    renderPreview() {
        const {currentFeatureIndex} = this.state
        let {newNotifications} = this.state
        const {previewNotification, showAll, notifications} = this.props

        if (previewNotification) {
            newNotifications = [previewNotification]
        }

        if (notifications?.length === 0) {
            return <P>{t('noNotifications')}</P>
        }

        const availableNotifications = sortNotificationsByScheduled(showAll ? (notifications?.length > 0 ? notifications : []) : (newNotifications?.length > 0 ? newNotifications : []))

        const activeFeature = previewNotification || availableNotifications?.[currentFeatureIndex]

        return (
            <>
                {activeFeature && (
                    <NotificationContent notification={activeFeature} showTitle={!!(previewNotification || showAll)} />
                )}

                <div style={{display: 'flex', justifyContent: 'flex-end', columnGap: formSpacing.columnGap}}>
                    {currentFeatureIndex !== 0 && (
                        <Button
                            label={t('previousWithCount', {current: currentFeatureIndex, total: availableNotifications.length})}
                            onClick={() => this.setState({currentFeatureIndex: currentFeatureIndex - 1})}
                        />
                    )}

                    {currentFeatureIndex === (availableNotifications.length - 1) ?
                        (!showAll && (
                            <Button
                                label={t('ok')}
                                onClick={this.onClickNextNotification.bind(this)}
                            />
                        )) :
                        <Button
                            label={t('nextWithCount', {current: currentFeatureIndex + 2, total: availableNotifications.length})}
                            onClick={this.onClickNextNotification.bind(this)}
                        />
                    }

                </div>
            </>
        )
    }

    render() {
        const {modalIsOpen, newNotifications, currentFeatureIndex} = this.state
        const {previewNotification, showAll} = this.props

        if (previewNotification || showAll) {
            return this.renderPreview()
        }

        const activeFeature = newNotifications?.[currentFeatureIndex]

        return (
            <Modal
                style={{paddingLeft: 32, paddingRight: 32}}
                show={modalIsOpen}
                title={activeFeature?.title}
                onClose={this.onDismiss.bind(this)}
            >
                {this.renderPreview()}
            </Modal>
        )
    }
}

export default NotificationsPopup
